import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initializeRuntimeConfig } from '../config/runtime';
import { initializeObservability } from '../observability/telemetry';
import { AppRoot } from './AppRoot';
import type { AppVariantConfig } from './variant';

function resolveRouterBaseName(basePath: string): string | undefined {
  if (basePath === '/') {
    return undefined;
  }

  return basePath.replace(/\/$/, '');
}

function applyThemeClass(themeClassName?: string) {
  if (!themeClassName) {
    return;
  }

  document.body.classList.add(themeClassName);
}

export function bootstrapVariantApp(config: AppVariantConfig) {
  const runtimeConfig = initializeRuntimeConfig({
    variant: config.variant,
    locale: config.locale,
  });

  initializeObservability();
  applyThemeClass(config.themeClassName);
  document.documentElement.lang = runtimeConfig.app.locale;

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <BrowserRouter basename={resolveRouterBaseName(runtimeConfig.app.basePath)}>
        <AppRoot config={config} />
      </BrowserRouter>
    </StrictMode>
  );
}
